import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
// antd v5's static APIs (Modal.confirm/message/notification, Button's wave-ripple effect)
// render via the legacy ReactDOM.render internally, which doesn't share React 19's createRoot
// event system — this breaks things like clicks on buttons inside Modal.confirm's content.
// Official antd patch: https://www.npmjs.com/package/@ant-design/v5-patch-for-react-19
import '@ant-design/v5-patch-for-react-19';
import App from './components/App';
import store from '../src/redux/store';

// antd v5 dropped Less-variable theming in favor of this token config, so the app's
// previous variables.less overrides (@primary-color etc.) no longer reach antd's own
// components on their own. This restores the same values via ConfigProvider.
const theme = {
  token: {
    colorPrimary: '#a6a300',
    colorLink: '#5277FC',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#900101',
    colorText: '#000',
    colorTextHeading: 'rgba(0, 0, 0, 0.85)',
    colorTextSecondary: 'rgba(0, 0, 0, 0.45)',
    colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
    colorBorder: '#acacac',
    fontSize: 14,
    fontFamily: 'Montserrat, sans-serif',
    borderRadius: 4,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  },
  components: {
    // antd v5's dark Menu adds rounded, margined item "pills" and its own navy submenu
    // background; v4 rendered flat full-width rows on the sidebar colour. Match v4.
    Menu: {
      darkItemBg: '#212329',
      darkSubMenuItemBg: '#212329',
      darkPopupBg: '#212329',
      darkItemColor: '#ffffff',
      darkItemHoverBg: '#333A4B',
      darkItemSelectedBg: '#333A4B',
      itemBorderRadius: 0,
      subMenuItemBorderRadius: 0,
      itemMarginBlock: 0,
      itemMarginInline: 0,
      itemHeight: 40,
      collapsedWidth: 80,
    },
  },
};

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <Router>
      <ConfigProvider theme={theme}>
        <App />
      </ConfigProvider>
    </Router>
  </Provider>
);
